import React, {useState, useEffect, useCallback} from 'react'
import {Navigate, Route, Routes, Outlet, useParams} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {ProfileDetailOverview} from '../../components/profile-detail/ProfileDetailOverview'
import {toast} from 'react-toastify'
import axios from 'axios'
import {ProfileDetailHeader} from '../../components/profile-detail/ProfileDetailHeader'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {USER_ROLES} from '../../../../constants/StatusConstants'
import RoutesRoleGuard from '../../components/permissions/RoutesPermissionGuard'
import {FaUser} from 'react-icons/fa'

interface LinkItem {
  title: string
  path: string
  label: string
  allowedRoles: number[]
  icon?: React.ReactNode
}

const MedicalAssistantDetailsPage: React.FC = () => {
  const notifyError = (msg: string) => toast.error(msg)

  const {medicalAssistantId} = useParams<{medicalAssistantId: string}>()
  const [userData, setUserData] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  const fetchDetails = useCallback(async () => {
    setLoading(true)
    try {
      const res = await axios.get(API_ENDPOINTS.GET_SPECIFIC_USER(medicalAssistantId))
      setUserData(res.data.data?.user)
    } catch (err) {
      notifyError('Failed to load medical assistant details.')
    } finally {
      setLoading(false)
    }
  }, [medicalAssistantId])

  useEffect(() => {
    fetchDetails()
  }, [fetchDetails])

  const accountBreadCrumbs: PageLink[] = [
    {
      title: 'Medical Assistant Details',
      path: `medical-assistant-details/${medicalAssistantId}`,
      isSeparator: false,
      isActive: false,
    },
    {title: '', path: '', isSeparator: true, isActive: false},
  ]

  const links: LinkItem[] = [
    {
      title: 'Overview',
      path: `/medical-assistant-details/${medicalAssistantId}/overview`,
      label: 'overview',
      allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.SUB_ADMIN],
      icon: <FaUser />,
    },
  ]

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleEditPress = () => setIsModalOpen(!isModalOpen)

  return (
    <>
      <Routes>
        <Route
          element={
            <>
              <ProfileDetailHeader
                user={userData}
                uuid={medicalAssistantId || ''}
                links={links}
                isLoading={loading}
              />
              <Outlet />
            </>
          }
        >
          <Route
            index
            element={<Navigate to={`/medical-assistant-details/${medicalAssistantId}/overview`} replace />}
          />

          <Route
            path='overview'
            element={
              <RoutesRoleGuard allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.SUB_ADMIN]}>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <ProfileDetailOverview
                  user={userData}
                  isLoading={loading}
                  onEditPress={handleEditPress}
                />
              </RoutesRoleGuard>
            }
          />

          <Route path='*' element={<Navigate to='/error/404' replace />} />
        </Route>
      </Routes>
    </>
  )
}

export default MedicalAssistantDetailsPage


